/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useState, Fragment } from 'react';
import { SiteLink } from '../../components';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import { NavBar } from './navBar';
import { BackButton } from '../backButton/backButton';
import { Hamburger } from '../hamburger/hamburger';
import style from './topHeaderStyle';

export function TopHeader(props) {
  const [menuOpened, setMenuOpened] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useScrollPosition(
    ({ prevPos, currPos }) => {
      if (currPos.y > 90) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    },
    [],
    null,
    true
  );
  function toggleMenu(e) {
    setMenuOpened(!menuOpened);
  }
  function onCloseMenu() {
    setMenuOpened(false);
  }
  return (
    <Fragment>
      <header
        css={[style.top, scrolled && style.topScrolled]}
        className={`${
          scrolled ? 'topHeader_style_scrolled' : 'topHeader_style'
        } `}
        id="top"
      >
        <BackButton />
        <SiteLink to="/" css={[style.logo, scrolled && style.logoScrolled]}>
          <img
            className="masthead_1"
            css={style.logoImg}
            src={
              scrolled && style.logoScrolled
                ? '/assets/logos/blue-masthead-seafront-logo.png'
                : '/assets/logos/white-masthead-seafront-logo.png'
            }
            alt="logo"
          />
          <img
            className="masthead_2"
            css={style.logoImg}
            src={
              scrolled && style.logoScrolled
                ? '/assets/logos/seafront-connnect-logo-navy.png'
                : '/assets/logos/seafront-connect-logo-white.png'
            }
            alt="logo"
          />
          <img
            className="masthead_3"
            css={style.logoImg}
            src={
              scrolled && style.logoScrolled
                ? '/assets/logos/the-penneshaw-pub-logo-green.png'
                : '/assets/logos/the-penneshaw-pub-logo-white.png'
            }
            alt="logo"
          />
          <img
            className="masthead_4"
            css={style.logoImg}
            src={
              scrolled && style.logoScrolled
                ? '/assets/logos/the-kiosk-logo-blue.png'
                : '/assets/logos/the-kiosk-logo-white.png'
            }
            alt="logo"
          />
          <img
            className="masthead_5"
            css={style.logoImg}
            src={
              scrolled && style.logoScrolled
                ? '/assets/logos/seafront-group-logo-navy.png'
                : '/assets/logos/seafront-group-logo-white.png'
            }
            alt="logo"
          />
          <img
            className="masthead_6"
            css={style.logoImg}
            src={
              scrolled && style.logoScrolled
                ? '/assets/logos/sea-front-holiday-park-navy.png'
                : '/assets/logos/sea-front-holiday-park-white.png'
            }
            alt="logo"
          />
        </SiteLink>
        <Hamburger
          opened={menuOpened}
          toggleMenu={toggleMenu}
          scrolled={scrolled}
        />
        <NavBar open={menuOpened} onCloseMenu={onCloseMenu}></NavBar>
        <div className="bg_dark_linear"></div>
      </header>
    </Fragment>
  );
}
